import { Fragment, FunctionComponent } from "react";
import { Global, css } from "@emotion/react";
import { datePickerStyles } from "./DatePicker";
import mixins from "./mixins";

export const GlobalStyleSheet: FunctionComponent = () => {
  return (
    <Fragment>
      <Global styles={GlobalStyles} />
      <Global styles={datePickerStyles} />
    </Fragment>
  );
};

const GlobalStyles = css`
  *,
  ::after,
  ::before {
    box-sizing: border-box;
  }

  html {
    height: 100%;
  }

  body {
    margin: 0;
    padding: 0;
    height: 100%;

    ${mixins.fontFira()};
    background-color: #f8f8f8 !important;
  }

  #root {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 0%;
  }
`;
